export default {
  title: 'Nakładająca się oferta w tym samym okresie',
  buttons: {
    save_as_active: 'Ustaw jako nową aktywną ofertę',
    save_as_inactive: 'Zapisz jako nieaktywną',
    cancel: 'Anuluj',
  },
  description: {
    base: '{{offer}} nakłada się z aktywną ofertą {{overlappingOffer}} w {{weekday}}{{between}}. W tym samym okresie może być aktywna tylko jedna oferta.',
    between: ', między {{start}}-{{end}}',
  },
  how_to_resolve: {
    title: 'Jak rozwiązać: Wybierz jedną z poniższych opcji.',
  },
};
